// import {productsearchList, RefundSaveAdd} from "./api";

export const SIGN_IN = 'signIn';

export const SIGN_OUT = 'signOut';

export const CAPTCHA = 'capTcha';

export const CHECK_IMG_CODE = 'checkImgCode';

export const CHECK_NEXT = 'checkNext';

export const UPDATE_PASS_WORD = 'updatePassWord';

export const ROLE_MENU_LIST = 'getRoleMenu';

export const CHILD_ROLE_MENU_LIST = 'getChildRoleMenu';

export const GET_ONLINE_USER_INFO = 'getOnlineUserInfo';

export const GET_USER_INFO = 'toUserInfo';

export const IS_ONLINE = 'isOnline';

export const USER_MANAGE_LIST = 'getUserManageList';

export const ADD_USER = 'addUser';

export const EDIT_USER = 'editUser';

export const DELETE_USER = 'deleteUser';

export const RESET_PASSWORD = 'resetPassword';

export const CHANGE_USER_PWD = 'changeUserPwd';

export const FREEZE_USER = 'freezeUser';

export const UNFREEZE_USER = 'unfreezeUser';

export const DEPT_TREE = 'getDeptTree';

export const ADD_DEPT = 'addDept';

export const UPDATE_DEPT = 'updateDept';

export const DEL_DEPT = 'delDept';

export const GET_ROLE_LIST = 'getRoleList';

export const ADD_ROLE = 'addRole';

export const EDIT_ROLE = 'editRole';

export const DEL_ROLE = 'delRole';

export const SET_ROLE_AUTHORITY = 'setRoleAuthority';

export const GET_DICT_LIST = 'getDictList';

export const ADD_DICT = 'addDict';

export const EDIT_DICT = 'editDict';

export const DEL_DICT = 'delDict';

export const GET_MENU_LIST = 'getMenuList';

export const ADD_MENU = 'addMenu';

export const EDIT_MENU = 'editMenu';

export const DEL_MENU = 'delMenu';

export const MENU_TREE_LIST_BY_ROLE_ID = 'menuTreeListByRoleId';

export const GET_LOGIN_LOG_LIST = 'getLoginLogList';

export const EMPTY_LOGIN_LOG = 'emptyLoginLog';

export const GET_OPERATION_LOG_LIST = 'getOperationLogList';

export const EMPTY_OPERATION_LOG = 'emptyOperationLog';

export const OPERATION_LOG_DETAIL = 'operationLogDetail';

export const NOTICE_LIST = 'noticeList';

export const ADD_NOTICE = 'addNotice';

export const DEL_NOTICE = 'delNotice';

export const EDIT_NOTICE = 'editNotice';

export const DATA_PERMISSION_LIST = 'dataPermissionList';

export const ADD_DATA_PERMISSION = 'addDataPermission';

export const UPDATE_DATA_PERMISSION = 'updateDataPermission';

export const DEL_DATA_PERMISSION = 'delDataPermission';

export const DATA_PERMISSION_RULE_LIST = 'dataPermissionRuleList';

export const ADD_DATA_PERMISSION_RULE = 'addDataPermissionRule';

export const DEL_DATA_PERMISSION_RULE = 'delDataPermissionRule';

export const CHOOSE_DATA_PERMISSION_RULE = 'chooseDataPermissionRule';

export const DATA_PERMISSION_GROUP_TYPE = 'dataPermissionGroupType';

export const DATA_PERMISSION_GROUP_NAME_LIST = 'dataPermissionGroupNameList';

export const DATA_PERMISSION_BINDING_GROUP = 'dataPermissionBindingGroup';

export const JOB_LIST = 'jobList';

export const ADD_JOB = 'addJob';

export const EDIT_JOB = 'editJob';

export const RECORDS_LIST = 'recordsList';

export const DELETE_JOB = 'deleteJob';

export const PAUSE_JOB = 'pauseJob';

export const FREEZE_JOB = 'freezeJob';

export const RESUME_JOB = 'resumeJob';

export const NOW_JOB = 'nowJob';

export const EXPORT_FILE_LIST = 'exportFilePageList';

export const DELETE_EXPORT_FILE_BY_CODES = 'deleteExportFileByCodes';

export const REPORT_FORM_LIST = 'reportFormsList';

export const REPORT_FORM_DELE = 'deleteReportForms';

export const REPORT_FORM_SEARCH_LIST = 'reportOrderSearchList';

export const VALIDATE_EXPORT_FILE = 'validateExportFile';

export const REPORT_EXPORT_FILE = 'reportExportFile';

export const MD_LOGISTICS_COMPANY_LIST = 'mdLogisticsCompanyList';

export const ADD_MD_LOGISTICS_COMPANY = 'addMdLogisticsCompany';

export const EDIT_MD_LOGISTICS_COMPANY = 'editMdLogisticsCompany';

export const DEL_MD_LOGISTICS_COMPANY = 'delMdLogisticsCompany';

export const SHOP_LIST = 'shopList';

export const MANU_LIST = 'manuList';

export const INIT_SHOP = 'initShop';

export const INIT_SHOP_LOGIC = 'initShopLogic';

export const SHOP_LOGIC_CARRY = 'shopLogicCarry';

export const ADD_SHOP = 'addShop';

export const ADD_SHOP_LOGIC = 'addShopLogic';

export const UPDATE_SHOP_LOGIC_DEFAULT = 'updateShopLogicDefault';

export const UPDATE_SHOP = 'updateShop';

export const GET_SHOP_BY_ID = 'getShopById';

export const GET_SHOP_BY_PLAM_ID = 'getShopByPlamId';

export const WAREHOUSE_LOG = 'warehouseLog';

export const WAREHOUSE_LIST = 'warehouseList';

export const ADD_WAREHOUSE = 'addWarehouse';

export const UPDATE_WAREHOUSE = 'updateWarehouse';

export const FREEZE_WAREHOUSE = 'freezeWarehouse';

export const UNFREEZE_WAREHOUSE = 'unfreezeWarehouse';

export const DELETE_WAREHOUSE = 'deleteWarehouse';

export const GET_AREAS = 'getAreas';

export const GET_AREA_BY_PID = 'getAreaByPid';

export const GET_AREA_BY_PID_NEW = 'getAreaByPidNew';

export const FIND_WAREHOUSE_BY_ID = 'findWarehouseById';

export const SALES_ACCOUNT_LIST = 'salesAccountList';

export const SALES_ACCOUNT_INIT = 'salesAccountInit';

export const SALES_ACCOUNT_DOWNLOAD_EXPORT = 'salesAccountDownloadExport';

export const TAX_BALANCE_LIST = 'taxBalanceList';

export const BALANCE_REPORT_LIST = 'balanceReportList';

export const TAX_BALANCE_INIT = 'taxBalanceInit';

export const TAX_BALANCE_DOWNLOAD_EXPORT = 'taxBalanceDownloadExport';

export const TAX_STATEMENT_LIST = 'taxStatementList';

export const TAX_STATEMENT_INIT = 'taxStatementInit';

export const TAX_STATEMENT_DOWNLOAD_EXPORT = 'taxStatementDownloadExport';

export const WAREHOUSE_STOCK_LIST = 'warehouseStockList';

export const WAREHOUSE_PLAN_LIST = 'warehousePlanList';

export const WAREHOUSE_PLAN_ITEM_LIST = 'warehousePlanItemList';

export const ADD_WAREHOUSE_STOCK = 'addWarehouseStock';

export const UPDATE_WAREHOUSE_STOCK = 'updateWarehouseStock';

export const UPDATE_SEA_WAREHOUSE_STOCK = 'updateSeaWarehouseStock';

export const CREATESTOCKPLAN = 'createStockPlan';

export const GET_WAREHOUSE_STOCK_DETAIL = 'getWarehouseStockDetail';

export const BRAND_LIST = 'brandList';

export const ADD_BRAND = 'addBrand';

export const UPDATE_BRAND = 'updateBrand';

export const DELETE_BRAND = 'deleteBrand';

export const MERCHANT_LIST = 'merchantList';

export const ADD_MERCHANT = 'addMerchant';

export const UPDATE_MERCHANT = 'updateMerchant';

export const DELETE_MERCHANT = 'deleteMerchant';

export const DELETE_MERCHANT_LIST = 'deleteMerchantList';

export const PRODUCT_LIST = 'productList';

export const PRODUCTsearch_LIST = 'productsearchList';
export const FIANCE_AFTER_EDIT = 'finance_after_edit';

export const PRODUCT_EDIT_INIT = 'productEditInit';

export const ADD_PRODUCT = 'addProduct';

export const UPDATE_PRODUCT = 'updateProduct';

export const UPDATE_ECP_PRODUCT = 'updateEcpProduct';

export const DELETE_PRODUCT_List = 'deleteProductList';

export const DELETE_PRODUCT_BY_ID = 'deleteProductById'

export const PRODUCT_DETAIL = 'productDetail';

export const ECP_PRODUCT_DETAIL = 'ecpProductDetail';

export const TEMP_SO_LIST = 'tempSoList';

export const TEMP_SO_IMPORT_LIST = 'tempSoImportList';

export const TEMP_SO_IMPORT_DATA = 'tempSoimportData';

export const TEMP_SO_DOWN_IMPORT_RESULT  = "downImportResult";

export const TEMP_SO_IMPORT_DATA_COMMIT = 'importDataCommit';

export const TEMP_SO_IMPORT_ORDER_DATA_COMMIT = 'importOrderDataCommit';

export const ECP_IMPORT_ORDER_DATA = 'importOrderData';

export const REFUND_IMPORT_REFUND = 'importRefund';

export const REFUND_IMPORT_REFUND_ORDER = 'ecpImportRefund';

export const PRO_EXCEL_IN = 'proExcelIn';

export const PRODUCT_EXCEL_IN = 'proDuctExcelIn';

export const REFUND_IMPORT_REFUND_LIST = 'importRefundList';

export const REFUND_IMPORT_DATA_COMMIT = 'importRefundCommit';

export const REFUND_IMPORT_DATA_ORDER_COMMIT = 'importRefundOrderCommit';

export const REFUND_DOWN_IMPORT_REFUND = 'downImportRefund';

export const REFUND_RefundSaveAdd = 'RefundSaveAdd';

export const REFUND_financeSaveAdd = 'RefundFinanceSaveAdd';
export const  ImportRefundPushEcpOrder = "importRefundPushEcpOrder"

export const  ImportPushEcpOrder = "importPushEcpOrder"

export const TEMP_SO_EXPORT = 'tempSoExport';

export const TEMP_SO_INIT = 'tempSoInit';

export const TEMP_SO_GENERATE = 'tempSoGenerate';

export const ECP_PUSH_POJO = 'ecpPushPojo';

export const PUSH_LIST_POJO = 'pushListPojo';

export const PUSH_LIST_POJOSTATE = 'pushListPojoState';
export const CLEAN_ORDER_PUSH = 'cleanOrderPush';

export const ECP_CLEAN_FINANCEACCOUNT = 'ecpCleanFinanceAccount';

export const ECP_MONITORING_LOG = 'ecpMonitoringLog';

export const TEMP_SO_PULLING_ORDER = 'tempSoPullingOrder';

export const SO_ORDER_LIST = 'soOrderList';

export const SO_ORDER_INIT = 'soOrderInit';

export const WARE_HOUSE_STOCK_INIT = 'warehouseStockInit';

export const ML_SALE_INIT = 'mlSaleInit';

export const ML_SALE_LIST = 'mlSaleList';

export const ML_SALE_ENT_IN = 'mlSaleEntIn';

export const ML_SALE_SUB = 'mlSaleSub';

export const SO_ORDER_EXPORT_VIRTUAL_ORDER = 'soOrderExportVirtualOrder';

export const SO_ORDER_EXPORT_TRUE_OUT = 'soOrderExportTrueOut';

export const SO_ORDER_PASS_STATUS = 'soOrderPassStatus';

export const TEMPSO_CHANGE_BILL = 'tempSoChangeBill';

export const SO_ORDER_NOT_REAL_PASS_STATUS = 'soOrderNotRealPassStatus';

export const SO_ORDER_PASS_STATUSNew = 'NewPassStatus';

export const SO_ORDER_PASS_STATUSPay = 'soOrderPassStatusPay';

export const SO_ORDER_CANCEL_ORDER = 'soOrderCancelOrder';

export const SO_ORDER_TO_UNUSUAL_ORDER = 'soOrderToUnusualOrder';

export const SO_ORDER_UNUSUAL_ORDER = 'soOrderUnusualOrder';

export const SO_ORDER_REMARK = 'soOrderRemark';

export const SO_ORDER_USER_UPDATE_INIT = 'soOrderUserUpdateInit';

export const SO_ORDER_CARRY_LOGIC = 'soOrderCarryLogic';

export const SO_ORDER_USER_UPDATE = 'soOrderUserUpdate';

export const SO_ORDER_UPDATE_LOGIC = 'soOrderUpdateLogic';

export const SO_OPERATE_LOG_LIST = 'soOperateLogList';

export const TEMP_SO_OPERATE_LOG = 'tempSoOperateLog';

export const mdskulog = "mdskulog";

export const mdProductLog = "mdProductLog";
export const mdComboProductLog = "mdComboProductLog";

export const REFUND_ORDER_LOG = 'refundOrderLog';

export const TEMP_SO_ToNormal = 'tempSOToNormal';

export const TEMP_SO_ToNormal_List = 'tempSOToNormalList';

export const TEMP_SO_batchCancel_List = 'tempBatchCancelList';

export const TEMP_SO_waitOrderDelete = 'waitOrderDelete';
export const verify_List = 'tempSOVerifyList';

export const TEMP_SO_DETAIL = 'tempSoDetail';

export const TEMP_SO_ITEM_LIST = 'tempSoItemList';

export const SO_ORDER_DETAIL = 'soOrderDetail';

export const SO_ORDER_LOGIC = 'soOrderLogic';

export const SO_ORDER_ITEM_LIST = 'soOrderItemList';

export const ECP_SOITEM_SYC = 'ecpSoItemSyc';

export const ECP_PRODUCT_HIS_LIST = 'ecpProductHisList';

export const SO_ORDER_CARRY_REMARK = 'soOrderCarryRemark';

export const SO_ORDER_CARRY_YOUZAN_REMARK = 'soOrderCarryYouZanRemark';

export const SO_ORDER_UPDATE_CARRY = 'soOrderUpdateCarry';

export const SO_ORDER_UPDATE_YOUZAN_CARRY = 'soOrderUpdateYouZanCarry';

export const GRF_HEADER_INIT = 'grfHeaderInit';

export const GRF_HEADER_LIST = 'grfHeaderList';

export const GRF_HEADER_DETAIL = 'grfHeaderDetail';

export const REFUND_ORDER_INIT = 'refundOrderInit';

export const REFUND_ORDER_LIST = 'refundOrderList';

export const TEMP_SO_TO_ABNORMAL = 'tempSOToAbnormal';

export const TEMP_SO_TO_HANDLE_ABNORMAL_GOODS = 'tempSOToHandleAbnormalGoods';

export const TEMP_SO_TO_UpdatePayOrderNo = 'tempSOUpdatePayOrderNo';

export const MD_COMBO_PRODUCT_LIST = 'mdComboProductList';

export const ADD_DETAIL_MD_COMBO_PRODUCT = 'addDetailMdComboProduct';

export const ADD_MD_COMBO_PRODUCT = 'addMdComboProduct';

export const MD_COMBO_PRODUCT_DETAIL = 'mdComboProductDetail';

export const UPDATE_MD_COMBO_PRODUCT = 'updateMdComboProduct';

export const DELETE_MD_COMBO_PRODUCT = 'deleteMdComboProduct';

export const PASS_ORDER_SHUANG_XIN = 'passOrderShuangXin';

export const REFOUND_DOWNLOAD_EXPORT = 'refoundDownloadExport';

export const GRF_DOWNLOAD_EXPORT = 'grfDownloadExport';

export const GRF_ITEM_LIST = 'grfItemList';

export const REFOUND_DETAIL = 'refoundDetail';

export const SALES_ACCOUNT_ORDER_LIST = 'salesAccountOrderList';

export const SALES_ACCOUNT_ORDER_INIT = 'salesAccountOrderInit';

export const SALES_ACCOUNT_ORDER_DOWNLOAD_EXPORT = 'salesAccountOrderDownloadExport';

export const TAX_REPORT_DELETE = 'taxReportDelete';

export const SAVE_TAX_EXPORT = 'saveTaxExport';

export const TAX_REPORT_INIT = 'taxReportInit';

export const SUPPLIER_INIT = 'supplierInit';

export const SKU_LIST = 'skuList';

export const SKU_EDIT_INIT = 'skuEditInit';

export const ADD_SKU = 'addSku';

export const UPDATE_SKU = 'updateSku';

export const SKU_DETAIL = 'skuDetail';

export const ORDER_INTERFACE_LOG_LIST = 'orderInterfaceLogList';

export const INTERFACE_LOG_REMARK = 'interfaceLogRemark';

export const ECP_TASK_LIST = 'ecpTaskList';

export const ECP_MONITORING_INIT = 'ecpMonitoringInit';

export const ECP_MONITORING_LIST = 'ecpMonitoringList'

export const ECP_PUSH_LIST='pushEcpPojo'

export const GET_PLATFORM_BY_ID = 'getPlatformById';

export const ADD_PLATFORM = 'addPlatform';

export const UPDATE_PLATFORM = 'updatePlatform';

export const PLATFORM_LIST = 'platformList';

export const DELETE_PLATFORM = 'deletePlatform';

export const ECP_TASK_HEAVYPUSH = 'heavyPush';

export const BATCH_STOCK_ADD_INIT = 'batchStockAddInit';

export const PM_BATCH_STOCK_LIST = 'pmBatchStockList';

export const REBATE_INIT = 'rebateInit';

export const BATCH_STOCK_ADD = 'batchStockAdd';

export const ML_STORE = 'mlstore';

export const ML_TERMINAL = 'mlterminal';

export const ML_REBATERULE = 'mlrebaterule'

export const ML_REBATERULE_DELETE = 'mlrebateruledelete';

export const ML_REBATERULE_GETROW = 'mlrebaterulegetrow';

export const ML_REBATERULE_ADDSAVE = 'mlrebateruleaddsave';

export const ML_REBATERULE_EDITSAVE = 'mlrebateruleeditsave';

export const BATCH_WAREHOUSE_STOCK_INIT = 'batchWarehouseStockInit';

export const BATCH_WAREHOUSE_STOCK_LIST = 'batchWarehouseStockList';

export const ML_RECEIPTREC_VERIFLOG = 'mlreceiptveriflog';

export const ML_RECEIPTREC_VERIF_TITLE = 'mlreceiptveriftitle';

export const ML_RECEIPTREC_VERIF_EXPORT = 'mlreceiptverifexport';

export const ML_RECEIPTREC_INIT = 'mlreceipt_init';

export const ML_RECEIPTREC_LIST = 'mlreceiptreclist';

export const BATCH_STOCK_DETAIL = 'batchStockDetail';

export const BATCH_STOCK_UPD = 'batchStockUpd';

export const BATCH_STOCK_DEL = 'batchStockDel';

export const BATCH_STOCK_ADD_PM = 'batchStockAddPm';

export const BATCH_FLOW_LIST = 'batchFlowList';

export const MLVERIFORDEREXPORT = 'mlveriforderexport';

export const FOCUS_DETAIL = 'focusDetail';

export const FOCUS_SUBMIT = 'focusSubmit';

export const ACCOUNT_DIS_LIST = 'accountDisList';

export const TRANSFER_ERROR_ORDER = 'transferErrorOrder';

export const ECP_SAVE_REMAKES = 'ecpSaveRemakes';

export const ECP_MONITORING_REFOUND_ORDER_ID = 'ecprefundOrderId';

export const MAKE_UP_BILL = 'makeUpBill';

export const ECP_UPDATEE_COMBINED_CODE = 'ecpUpdateCombinedCode';

export const MD_ECP_TRANSFORM = 'mdEcpTransform'

export const UPDAYE_FLAG = 'mdEcpTransformDelete'

export const UPDAYE_FLAG_LIST = 'mdEcpTransformDeleteSize'

export const ECP_DERIVR = 'ecpDerive'

export const SPECIA_ADDRESS_INIT = 'speciaAddressInit';

export const DELETE_BRANDLIST = 'deletedBrandList'

export const BRAND_DETAIL = 'brandDetail'

export const UPADTE_ADDRESS = 'updateAddress'

export const UPDATE_ID = 'updateAddressId'

export const ADD_ADDRESS = 'addAddress'

export const GET_ADDRESS_TYPE = 'getAddressType'

export const DELETE_ADDRESS = 'deleteAddress'

export const ARTICLE_DEL = 'articleDel'

export const TO_WAREHOUSE_STOCK = 'ToUpdateWarehouseStock';

export const LOG_WAREHOUSE_STOCK = 'WarehouseStockLog';

export const LOCK_WAREHOUSE_STOCK = 'WarehouseStockLock';

export const DEL_WAREHOUSE_STOCK = 'ToDelWarehouseStock';

export const SO_ORDER_ABNORMAL = 'soOrderToAbnormal';

export const SO_ORDER_UPDATE_ABNORMAL = 'soOrderUpdateAbnormal';



// WEBPACK FOOTER //
// ./src/api/methods.js